module.exports = __webpack_public_path__ + "img/hsbc.2cda19d9.png";